import { useEffect, useState } from "react";
import { Icon } from "./Icon";
import { useT } from "./i18n";
import { navigate, useQueryParam } from "./router";
import { RefreshButton } from "./Refresh";

export function TopSearch() {
  const t = useT();
  const saved = useQueryParam("q");
  const savedType = useQueryParam("type");
  const [query, setQuery] = useState(saved ?? "");
  const [kind, setKind] = useState(savedType === "users" ? "users" : "messages");
  useEffect(() => { if (saved !== null) setQuery(saved); }, [saved]);
  useEffect(() => { if (savedType) setKind(savedType === "users" ? "users" : "messages"); }, [savedType]);
  return <div className="workspace-search"><form role="search" onSubmit={(e) => { e.preventDefault(); if (query.trim()) navigate(`/search?type=${kind}&q=${encodeURIComponent(query.trim())}`); }}>
    <Icon name="search" size={18} />
    <input type="search" aria-label={t.browse.search} placeholder={t.browse.searchPlaceholder} value={query} onChange={(e) => setQuery(e.target.value)} />
    <select aria-label={t.browse.search} value={kind} onChange={(e) => setKind(e.target.value)}><option value="users">{t.browse.users}</option><option value="messages">{t.browse.messages}</option></select>
    <button className="icon-button" type="submit" aria-label={t.browse.search} disabled={!query.trim()}><Icon name="search" size={17} /></button>
  </form><RefreshButton /></div>;
}
